import * as React from 'react';

const YoutubeIcon = (props) => (
    <svg width={30} height={30} fill="none" {...props}>
        <circle cx={15} cy={15} r={15} fill="red" />
        <mask
            id="a"
            width={30}
            height={30}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance'
            }}
        >
            <circle cx={15} cy={15} r={15} fill="#fff" />
        </mask>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M23 17.423v-5.346S23 9.5 20.415 9.5h-9.83S8 9.5 8 12.077v5.346S8 20 10.584 20h9.831S23 20 23 17.423Zm-4.588-2.665-4.91 2.874v-5.75l4.91 2.876Z"
            clipRule="evenodd"
        />
    </svg>
);

export default YoutubeIcon;
